import React from "react";

import { introTranslation } from "data/about/translationAbout";

const AboutIntro = (props) => {
    return (
        <section className="about-intro-section">
            <h3>{introTranslation.title[props.language]} &#128075;</h3>
            <h4
                dangerouslySetInnerHTML={{
                    __html: introTranslation.intro[props.language],
                }}
            ></h4>
        </section>
    );
};

export default AboutIntro;
